import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { FullTable, DownloadCsv, AddButton, EditWithIcon, SelectedFilters } from 'components';
import { RolePermission, PermissionList, useModal, sortListByKey, Images } from 'utils';
import { CreateFundingSource, PayerCapabilities } from 'fragments';
import { fundingSourceActions } from 'store';
import { ACTION_TYPE, fsBody, fsHead, fsNotYet, fsStatusEnums, fsStatusFilterList, payerTypeOptions } from './constants';

export const FundingSource = () => {
    const fundingSourceList = useSelector((state) => state.fundingSource.fundingSourceList);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const { open } = useModal();

    /**
     * Every filter this grid has, all of them column-header controls plus the top-bar search.
     *
     * There is no filter popover here, unlike the other grids: `PayerGetDTO` accepts only `status`,
     * `type` and the search pair, and both `status` and `type` already have a column dropdown — so
     * a popover would either sit empty or duplicate the columns.
     */
    const filtersList = [
        { name: 'Type', key: 'type', options: payerTypeOptions },
        // `ALL` is the column's own "no status filter" option — a choice, but not a narrowing one,
        // and absent means the ACTIVE default `getFsSources` re-applies. Neither is a chip.
        { name: 'Status', key: 'status', options: fsStatusFilterList, skipValues: ['ALL'] },
        { name: 'Search', key: 'searchValue', companions: ['searchKey'] },
    ];

    const getFsSources = () => {
        const filteredInfo = {
            ...info,
        };
        filteredInfo.skip = info?.skip ? info?.skip : 0;
        filteredInfo.limit = 50;

        if (info?.status === 'ALL') {
            delete filteredInfo.status;
        } else if (!info?.status) {
            filteredInfo.status = fsStatusEnums.ACTIVE;
        } else if (info?.status) {
            filteredInfo.status = info?.status;
        }
        delete filteredInfo.page;
        delete filteredInfo.activeTab;
        delete filteredInfo.name;
        dispatch(fundingSourceActions.getFundingSource(filteredInfo));

        return filteredInfo;
    };

    useEffect(() => {
        getFsSources();
    }, [info]);

    const handleNavigate = (id) => {
        if (RolePermission([PermissionList.FS_READ?.code])) {
            navigate(`/fundingSource/${id}`);
        }
    };

    return (
        <div>
            <div className="flex-end" style={{marginBottom: 12}}>
                <div className="flex-align-center" style={{ gap: 16 }}>
                    {/*<EditWithIcon icon={Images.infoCircle} handleClick={() => open(<PayerCapabilities />)} />*/}
                    <button
                        className={'download-csv-btn-small'}
                        onClick={() => open(<PayerCapabilities />)}
                    >
                        <img src={Images.infoCircle} alt="info" />
                    </button>
                    <DownloadCsv type={'fundingSource'} />
                    {RolePermission([PermissionList.FS_CREATE.code]) && (
                        <AddButton text={'Add Payer'} handleClick={() => open(<CreateFundingSource closeToSuccess={getFsSources} />)} />
                    )}
                </div>
            </div>

            <SelectedFilters filtersList={filtersList} doNotCrop />

            <FullTable
                head={fsHead}
                body={fsBody}
                loadingType={ACTION_TYPE}
                // list={fundingSourceList?.funders}
                list={sortListByKey(fundingSourceList?.funders, 'name', info)}
                listCount={fundingSourceList?.count}
                handleClick={handleNavigate}
                notYet={fsNotYet}
                detailPage={(item) => RolePermission([PermissionList.FS_READ?.code]) && `/fundingSource/${item?.id}`}
                margin={'12px 0 0'}
            />
        </div>
    );
};
